import { render, staticRenderFns } from "./customerContact.vue?vue&type=template&id=375b3bbe&scoped=true&"
import script from "./customerContact.vue?vue&type=script&lang=js&"
export * from "./customerContact.vue?vue&type=script&lang=js&"
import style0 from "./customerContact.vue?vue&type=style&index=0&id=375b3bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375b3bbe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('375b3bbe')) {
      api.createRecord('375b3bbe', component.options)
    } else {
      api.reload('375b3bbe', component.options)
    }
    module.hot.accept("./customerContact.vue?vue&type=template&id=375b3bbe&scoped=true&", function () {
      api.rerender('375b3bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataStatistics/components/customerContact.vue"
export default component.exports